module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/242-madagascar-461c69ba15e16ac8ef9986ac91ca7cae.svg";